import React from "react";
import "./Skeleton.scss";

interface SkeletonProps {
  className?: string;
  style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({ className = "", style }) => (
  <div className={`skeleton-block ${className}`.trim()} style={style} />
);

export default Skeleton;
